module.exports = __webpack_public_path__ + "img/fondo-banner-principal.110a0494.png";